module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal-header"
  }, [(_vm.title || _vm.$slot.toolbar) ? _c('div', {
    staticClass: "rt-header__main"
  }, [_c('h1', {
    staticClass: "rt-header__title"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "rt-header__action"
  }, [_vm._t("toolbar"), _vm._v(" "), _vm._t("mainbtn"), _vm._v(" "), (_vm.showBack) ? _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "60px",
      "height": "30px"
    },
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("返回")]) : _vm._e()], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a797e230"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/header/src/main.vue
// module id = 1533
// module chunks = 91